module.exports = __webpack_public_path__ + "media/images/del-c030e92fa9b8a667832664ca1a6c5cb3.png";